import InstantWinForm from "./instantWinForm.container";

export default InstantWinForm;
